<script>
export default {
  name: 'defaultForm',
  data  : () => ( {

  } ),
  methods : {
    sendForm(){

      let form = event.target.closest("form");
      let valid = true;
      form.querySelectorAll("input, textarea").forEach((input) => {
        if(input.closest(".form_row"))
          {
            if( input.checkValidity() )
              {
                input.closest(".form_row").classList.remove("error");
                if(input.classList.contains("mask-phone") === true){

                  let phone = input.value.match(/\d+/ig).join("");
                  if( phone.length < 11 )
                    {
                      input.closest(".form_row").classList.add("error");
                      valid=false;
                    }
                }
              }
            else
              {
                input.closest(".form_row").classList.add("error");
                valid=false;
              }
          }
      });
      if(valid !== true){
        event.preventDefault();
      }
      return valid;
    },
  },
}
</script>
